import { GlobalContext } from "contexts/GlobalContext";
import { ReactNode, useContext } from "react";
import { CodeProps } from "types/CodeProps";
import { ModalConfirmButton } from "components/buttons/ModalConfirmButton";
import { useTooltip } from "hooks/useTooltip";

export const EndGameButton = (
    props: CodeProps & { btnClass?: string; btnText: ReactNode; onCompleted?: () => void },
) => {
    const { code, btnClass = "dropdown", btnText, onCompleted } = props;

    const { setWindowConfirm, moderateService, catchServerError, addNotification } = useContext(GlobalContext);
    const { endGame } = moderateService;

    const { tooltipRef } = useTooltip({ title: "End game" });

    return (
        <div ref={tooltipRef}>
            <ModalConfirmButton
                btnText={btnText}
                className={btnClass}
                title="End the game?"
                confirmText="End game"
                description="You will not be able to resume the game, but all completed rounds will be saved."
                confirmIcon="fas fa-forward-step"
                onConfirm={() => {
                    setWindowConfirm(old => old && { ...old, loading: true });

                    endGame({ code })
                        .then(x => {
                            if (x.success) {
                                setWindowConfirm(old => old && { ...old, successMessage: "Game ended" });

                                if (onCompleted) {
                                    onCompleted();
                                }
                            } else {
                                addNotification({
                                    title: "Failed to end game",
                                    type: "failure",
                                });
                            }
                        })
                        .catch(catchServerError);
                }}
            />
        </div>
    );
};
